"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.Toggle = void 0;

var React = _interopRequireWildcard(require("react"));

var _Checkbox = _interopRequireDefault(require("../../components/Checkbox"));

// default to just passing the English label through
var passthrough = function passthrough(s) {
  return s;
};

var Toggle = function Toggle(_ref) {
  var _ref$t = _ref.t,
      t = _ref$t === void 0 ? passthrough : _ref$t;
  return /*#__PURE__*/React.createElement(_Checkbox["default"], {
    toggle: true,
    defaultChecked: true,
    className: "button basic inverted compact left-label",
    style: {
      backgroundColor: 'transparent'
    },
    label: t('New Experience')
  });
};

exports.Toggle = Toggle;
var _default = Toggle;
exports["default"] = _default;